import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { HttpService } from '../../services/http/http-service.service';
import { NzMessageService } from 'ng-zorro-antd';
import {CommonService} from '../../services/common/common.service';

@Component({
  selector: 'app-s-checkbox-group',
  templateUrl: './s-checkbox-group.component.html',
  styleUrls: ['./s-checkbox-group.component.less']
})
export class SCheckboxGroupComponent implements OnInit {

  @Input() config;

  constructor(
    private httpService: HttpService,
    private message: NzMessageService,
    private commonService: CommonService
  ) { }
  dataList = [];
  checked = false;
  loading = false;

  ngOnInit(): void {
    if (this.config.url) {
      this.getData();
    }
  }

  getData() {
    this.loading = true;
    const url = this.config.url;
    const params = this.config.params || {};
    this.httpService.httpGet(url, params).subscribe(res => {
      this.loading = false;
      if (res.code === 1) {
        this.initCheckOptionsData(res.data.mapperList);
      }
    });
  }

  initCheckOptionsData(data) {
    this.dataList = [];
    if (!data.length) { return; }
    data.forEach((d) => {
      d.label = d.showFormatter.showName;
      d.value = d.showFormatter.propertyName;
      d.checked = false;
      if (d.showFormatter.fiexToExport) {
        const fiex = d.showFormatter.fiexToExport.toLowerCase();
        if (JSON.parse(fiex)) {
          d.checked = true;
          d.disabled = true;
          d.fixed = true;
        }
      }
    });
    this.dataList = data;
  }

  isCheckedAll(checked) {
    this.setOptionsCheckedOrNot(checked);
  }

  setOptionsCheckedOrNot(checked) {
    this.dataList.forEach((item) => {
      if (!item.fixed) {
        item.checked = checked;
      }
    });
  }

  geCustomHeaders() {
    const result = [];
    this.dataList.forEach((d) => {
      if (d.checked) {
        const temp = { code: d.value, displayName: d.label };
        result.push(temp);
      }
    });
    return result;
  }
  cancel() {
    this.config.modal.close();
  }
  export() {
    const tagData = this.config.tagData;
    const params = {
      projectIds: ''
    };
    const ids = [];
    if (Object.keys(tagData).length > 0) {
      for (const key in tagData) {
        if (tagData[key]) {
          ids.push(key);
        }
      }
      params.projectIds = ids.join(',');
    }
    if (this.config.type === 'excel') {
      Object.defineProperty(params, 'customHeaders', { value: this.geCustomHeaders(), enumerable: true });
    }
    this.commonService.downLoad(this.config.exportUrl, 'POST', params);
  }
  exportAfter() {
  }

  checkedChange(item, checked) {
    item.checked = checked;
  }
}
